// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"278":"95986fd3192d23c8bfbd","298":"6b98a28968ab325cef5f","478":"1369f57b84b6904bb5ca","896":"c62d46e7f00406dceb21"}[chunkId] + ".js";
};